import React, { useContext, useEffect } from 'react';
import { MapChildContext } from '../context.js';
import useDimension from './useDimension.js';

const style = {
  padding: 0
};
function MapContainer(props) {
  const {
    className
  } = props;
  const {
    mapContainerRef,
    map
  } = useContext(MapChildContext);
  const rect = useDimension(mapContainerRef);
  useEffect(() => {
    if (map) {
      map.resize();
    }
  }, [rect, map]);
  return /*#__PURE__*/React.createElement("div", {
    ref: mapContainerRef,
    className: className,
    style: style
  });
}

export { MapContainer as default };
//# sourceMappingURL=index.js.map
